import TableContainer from '@material-ui/core/TableContainer'
import { TableBody, TablePagination } from '@material-ui/core'
import React, { useState } from 'react'
import { getSorting, stableSort } from '../../Components/Table/TableUtils'
import _ from 'lodash'
import EnhancedTableHead from '../../Components/Table/EnhancedTableHead'
import Table from '@material-ui/core/Table'

export const TableExtensions = ({ items, headCells, renderTableBody, search = '', tableSize = 'small' }) => {
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const filterFieldList = headCells.filter(item => item.filter === true).map(item => item.id)
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  function format(value) {
    console.log('format', value)
    if (value) {
      let result = value.toLowerCase()
      result = result.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      result = _.replace(result, '_', '')
      return result
    }
    return value
  }

  const filter = list =>
    list.filter(item => {
      if (search) {
        for (let field of filterFieldList) {
          if (format('' + item[field]).includes(format(search))) {
            return true
          }
        }
        return false
      } else {
        return true
      }
    })

  const handleRequestSort = (event, property) => {
    if (orderBy === property) {
      setOrder(order === 'desc' ? 'asc' : 'desc')
    } else {
      setOrder('asc')
      setOrderBy(property)
    }
  }

  let listItem = stableSort(filter(items), getSorting(order, orderBy))
  return (
    <TableContainer>
      <Table size={tableSize}>
        <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} headCells={headCells} />
        <TableBody>{renderTableBody(listItem.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))}</TableBody>
      </Table>
      <TablePagination
        labelDisplayedRows={({ count, page }) => 'page ' + (page + 1) + ' sur ' + Math.ceil(count / rowsPerPage)}
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={listItem.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage=""
        style={{ backgroundColor: '#f5f5f5' }}
      />
    </TableContainer>
  )
}
